import { TagDTO } from '@gearbelt/global';
import { v4 as uuidv4 } from 'uuid';

import { UpdateWorkspaceEntityDialog, type UpdateWorkspaceEntityDialogConfig } from '@/components/settings/update-workspace-entity-dialog';

const tagConfig: UpdateWorkspaceEntityDialogConfig<TagDTO> = {
  title: 'Work Order Tags',
  description: 'Tags let you group work orders by custom labels. You can reorder them to control how they appear in the dropdown menu.',
  createEmptyItem: () => ({
    id: uuidv4(),
    tag: '',
    order: 9999,
  }),
  getValue: (item) => item.tag,
  setValue: (item, value) => ({ ...item, tag: value }),
};

function UpdateWorkspaceWorkOrderTags({
  workOrderTags,
  open,
  onOpenChange,
  callback,
}: {
  workOrderTags: TagDTO[] | undefined;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  callback: (tags: TagDTO[]) => void;
}) {
  return <UpdateWorkspaceEntityDialog items={workOrderTags} open={open} onOpenChange={onOpenChange} callback={callback} config={tagConfig} />;
}

export { UpdateWorkspaceWorkOrderTags };
